import {
  Component, NgModule, Input, Output, EventEmitter, OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';

import { UserPanelModule } from '../user-panel/user-panel.component';
import { AuthService, IUser } from '../../../services';
import { ThemeSwitcherModule } from '../theme-switcher/theme-switcher.component';
import { KeycloakService } from 'keycloak-angular';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-header',
  templateUrl: 'app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
})

export class AppHeaderComponent implements OnInit {
  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  user: IUser | null = { email: '' };

  userMenuItems = [
  {
    text: 'Logout',
    icon: 'runner',
    onClick: () => {
      this.keycloakService.logout();
    },
  }];

  constructor(private keycloakService: KeycloakService) { }

  ngOnInit() { 
    var resultingToken;
    this.keycloakService.getToken().then((token)=> {
        resultingToken = jwtDecode(token);
        
    });

    this.keycloakService.loadUserProfile().then((usr) => {

      this.user = {
        email: (usr.email as string),
        avatarUrl: 'https://dev-auth.bitventure.co.za/resources/bywtc/login/bitventure/public/logo.svg'
      };
    });
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  };
}

@NgModule({
  imports: [
    CommonModule,
    DxButtonModule,
    DxToolbarModule,
    ThemeSwitcherModule,
    UserPanelModule,
  ],
  declarations: [AppHeaderComponent],
  exports: [AppHeaderComponent],
})
export class AppHeaderModule { }
